module.exports = require('./src/vue-timepicker.vue')



//////////////////
// WEBPACK FOOTER
// ./~/vue2-timepicker/index.js
// module id = 1176
// module chunks = 4